export default __webpack_public_path__ + "static/media/ic_arrow_mydata_location_hc.508c6b04.svg";